import * as z from "zod/v4";

export const refreshShippingRates = {
  name: "refreshShippingRates" as const,
  input: z.object({ fulfillmentGroupIds: z.array(z.string()) }),
  output: z.object({}),
};
